import React, {FC,useState,useEffect,useContext} from 'react'
import {fetchProjects} from '../../../app/helpers/remoteData'
import {BroadcastCampaign} from './BroadcastWrapper'
import {Stat} from './Stat'
import {RemoteDataContext} from '../../providers/RemoteDataProvider'
import {ClientContext} from '../../providers/ClientProvider'

type Props = {
    archived: boolean
}

const Stats: FC<Props> = ({archived}) => {
    const { broadcasts, setBroadcasts } = useContext(RemoteDataContext)
    const { client } = useContext(ClientContext)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        const fetchCableProjects = async () => {
            if (client.broadcast) {
                setIsLoading(true)
                const _projects: BroadcastCampaign[] = await fetchProjects(client.broadcast, archived)
                console.log('PROJECTS', _projects)
                setBroadcasts(_projects)
                setIsLoading(false)
            }
        }
        fetchCableProjects()
    }, [setBroadcasts, client.broadcast, archived])

    return (
        <div className='row gy-5 g-xl-8'>
            {
                isLoading ? 
                <div className="text-center pt-5">
                    <p>Stats are loading...</p>
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
                :
                <>
                    {
                        broadcasts.length > 0 ?
                            <>
                                {
                                    broadcasts.map((x, i) => <Stat key={`stat-${i}`} data={x} />)
                                }
                            </>
                        :
                        null
                    }
                </>
            }
        </div>
    )
}

export {Stats}
